"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validator = exports.isEmpty = void 0;
var validator = {
  validateNumber: function validateNumber(num) {
    var numberOnlyRegex = /^[۰-۹0-9\b]+$/;
    return numberOnlyRegex.test(num) && num;
  }
};
exports.validator = validator;

var isEmpty = function isEmpty(v) {
  return v === "" || v === null;
};

exports.isEmpty = isEmpty;